/* Jwear shared bottom-right FAB stacker.
   Finds sticky ATC / cookie / Shopify Inbox / AI chat / gift box and assigns
   bottom offsets so nothing overlaps. Components read --jw-fab-stack-bottom. */
(function () {
  'use strict';

  if (window.__jwFabStack) return;
  window.__jwFabStack = true;

  var GAP = 12;
  var EDGE_DESKTOP = 24;
  var EDGE_MOBILE = 10;
  var MOBILE_MQ = '(max-width: 699px)';
  var RIGHT_ZONE = 0.45; /* only stack widgets in the right ~55% */

  var frame = 0;
  var timer = 0;
  var observed = [];

  function edge() {
    return window.matchMedia(MOBILE_MQ).matches ? EDGE_MOBILE : EDGE_DESKTOP;
  }

  function findInShadow(host, selector, depth) {
    if (!host || depth > 3) return null;
    var sr = host.shadowRoot;
    if (!sr) return null;
    var hit = sr.querySelector(selector);
    if (hit) return hit;
    var all = sr.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      if (all[i].shadowRoot) {
        hit = findInShadow(all[i], selector, depth + 1);
        if (hit) return hit;
      }
    }
    return null;
  }

  function isShown(el) {
    if (!el || el.hidden) return false;
    if (el.hasAttribute && el.hasAttribute('hidden')) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    if (parseFloat(style.opacity) === 0) return false;
    /* Prestige cart/menu lock: launchers intentionally hide */
    if (document.documentElement.classList.contains('lock')) {
      if (el.matches && (el.matches('[data-jw-gift-launcher], [data-jw-chat-launcher]') || el.closest('[data-jw-gift], [data-jw-chat]'))) {
        return false;
      }
    }
    var rect = el.getBoundingClientRect();
    return rect.width >= 1 && rect.height >= 1;
  }

  function rightColumn(rect, vw) {
    return rect.left > vw * RIGHT_ZONE;
  }

  function stickyFloor(vh, vw) {
    var sticky =
      document.querySelector('.product-sticky-bar.is-visible') ||
      document.querySelector('product-sticky-bar.is-visible');
    if (!isShown(sticky)) {
      /* CSS var from main-product.liquid as fallback when bar is mid-transition */
      var cssOffset = parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--jw-pdp-sticky-atc-offset')
      );
      if (!isNaN(cssOffset) && cssOffset > 0 && window.matchMedia(MOBILE_MQ).matches) {
        return cssOffset;
      }
      return 0;
    }
    var rect = sticky.getBoundingClientRect();
    if (rect.top < vh * 0.5) return 0; /* desktop top sticky bar — ignore */
    return Math.max(0, vh - rect.top);
  }

  function collectFabs(vw, vh) {
    var items = [];

    /* 1) Shopify Inbox / Chat app (primary lowest when present) */
    var chatHost = document.querySelector('shopify-chat');
    var inboxBtn =
      findInShadow(chatHost, 'button.activator', 0) ||
      findInShadow(chatHost, '.activator', 0) ||
      findInShadow(chatHost, '[role="button"]', 0);
    if (chatHost && isShown(inboxBtn)) {
      var inboxRect = inboxBtn.getBoundingClientRect();
      if (rightColumn(inboxRect, vw)) {
        items.push({
          id: 'inbox',
          priority: 10,
          el: chatHost,
          measure: inboxBtn,
          apply: function (bottomPx) {
            chatHost.style.setProperty('--shopify-chat-activator-offset', Math.round(bottomPx) + 'px');
            chatHost.style.setProperty('--jw-fab-stack-bottom', Math.round(bottomPx) + 'px');
          },
          clear: function () {
            chatHost.style.removeProperty('--jw-fab-stack-bottom');
            /* leave theme.css / product offset as fallback by clearing inline only when we set it */
            chatHost.style.removeProperty('--shopify-chat-activator-offset');
          }
        });
      }
    }

    /* 2) AI chat launcher */
    var aiRoot = document.querySelector('[data-jw-chat]');
    var aiLauncher = document.querySelector('[data-jw-chat-launcher]');
    var aiOpen = aiRoot && aiRoot.classList.contains('is-open');
    if (aiLauncher && isShown(aiLauncher) && !aiOpen) {
      items.push({
        id: 'ai-chat',
        priority: 20,
        el: aiLauncher,
        measure: aiLauncher,
        apply: function (bottomPx) {
          aiLauncher.style.setProperty('--jw-fab-stack-bottom', Math.round(bottomPx) + 'px');
        },
        clear: function () {
          aiLauncher.style.removeProperty('--jw-fab-stack-bottom');
        }
      });
    } else if (aiRoot && aiOpen) {
      /* Open panel: only clear launcher stack; floor applied separately */
      if (aiLauncher) aiLauncher.style.removeProperty('--jw-fab-stack-bottom');
    }

    /* 3) Gift box launcher (above chat) */
    var giftRoot = document.querySelector('[data-jw-gift]');
    var giftLauncher = document.querySelector('[data-jw-gift-launcher]');
    var giftModalOpen = giftRoot && giftRoot.classList.contains('is-modal-open');
    if (giftLauncher && isShown(giftLauncher) && !giftModalOpen) {
      items.push({
        id: 'gift',
        priority: 30,
        el: giftLauncher,
        measure: giftLauncher,
        apply: function (bottomPx) {
          giftLauncher.style.setProperty('--jw-fab-stack-bottom', Math.round(bottomPx) + 'px');
          if (giftRoot) giftRoot.style.setProperty('--jw-gift-bottom', Math.round(bottomPx) + 'px');
        },
        clear: function () {
          giftLauncher.style.removeProperty('--jw-fab-stack-bottom');
          if (giftRoot) giftRoot.style.removeProperty('--jw-gift-bottom');
        }
      });
    }

    /* 4) Cookie banner — above launchers so it never covers them */
    var cookie =
      document.querySelector('[data-jw-cookie-banner].is-visible') ||
      document.querySelector('#jw-cookie-banner.is-visible') ||
      document.querySelector('[data-jw-cookie-banner]:not([hidden])');
    if (cookie && isShown(cookie)) {
      var cookiePanel = cookie.querySelector('.jw-cookie-banner__panel') || cookie;
      var cookieRect = cookiePanel.getBoundingClientRect();
      if (rightColumn(cookieRect, vw) || cookieRect.width > vw * 0.5) {
        items.push({
          id: 'cookie',
          priority: 40,
          el: cookie,
          measure: cookiePanel,
          apply: function (bottomPx) {
            cookie.style.setProperty('--jw-fab-stack-bottom', Math.round(bottomPx) + 'px');
            cookie.style.setProperty('--jw-cookie-stack-bottom', Math.round(bottomPx) + 'px');
          },
          clear: function () {
            cookie.style.removeProperty('--jw-fab-stack-bottom');
            cookie.style.removeProperty('--jw-cookie-stack-bottom');
          }
        });
      }
    }

    items.sort(function (a, b) {
      return a.priority - b.priority;
    });
    return items;
  }

  function measureHeight(item) {
    var rect = item.measure.getBoundingClientRect();
    var h = rect.height;
    if (h < 1) {
      /* temporarily clear our bottom so natural size is measurable next frame */
      h = item.measure.offsetHeight || 52;
    }
    return h;
  }

  function stack() {
    frame = 0;
    var vw = document.documentElement.clientWidth || window.innerWidth;
    var vh =
      (window.visualViewport && window.visualViewport.height) ||
      window.innerHeight ||
      document.documentElement.clientHeight;

    var floor = Math.max(edge(), stickyFloor(vh, vw));
    document.documentElement.style.setProperty('--jw-fab-stack-floor', Math.round(floor) + 'px');

    /* Open AI panel docks just above the floor (not the launcher stack). */
    var aiRoot = document.querySelector('[data-jw-chat]');
    if (aiRoot && aiRoot.classList.contains('is-open')) {
      aiRoot.style.setProperty('--jw-chat-bottom', Math.round(floor + (floor > 0 ? GAP : 0)) + 'px');
    }

    var items = collectFabs(vw, vh);
    var cursor = floor > 0 ? floor + GAP : edge();

    /* Two-pass: apply tentative bottoms, then remeasure heights and re-apply.
       Avoids reading layout while previous offsets still collide. */
    items.forEach(function (item) {
      item.apply(cursor);
      cursor += measureHeight(item) + GAP;
    });

    cursor = floor > 0 ? floor + GAP : edge();
    items.forEach(function (item) {
      item._bottom = cursor;
      item.apply(cursor);
      cursor += measureHeight(item) + GAP;
    });

    /* Clear vars on known hosts that are no longer stacked */
    clearAbsent(items);
  }

  var lastIds = {};
  function clearAbsent(items) {
    var next = {};
    items.forEach(function (item) {
      next[item.id] = item;
    });
    Object.keys(lastIds).forEach(function (id) {
      if (!next[id] && lastIds[id] && typeof lastIds[id].clear === 'function') {
        lastIds[id].clear();
      }
    });
    lastIds = next;
  }

  function request() {
    if (frame) return;
    frame = window.requestAnimationFrame(stack);
  }

  function observeEl(el) {
    if (!el || observed.indexOf(el) !== -1) return;
    observed.push(el);
    if (window.MutationObserver) {
      new MutationObserver(request).observe(el, {
        attributes: true,
        attributeFilter: ['class', 'hidden', 'style', 'aria-hidden']
      });
    }
    if (window.ResizeObserver) {
      try {
        new ResizeObserver(request).observe(el);
      } catch (e) {}
    }
  }

  function bindObservers() {
    observeEl(document.documentElement);
    observeEl(document.querySelector('[data-jw-gift]'));
    observeEl(document.querySelector('[data-jw-gift-launcher]'));
    observeEl(document.querySelector('[data-jw-chat]'));
    observeEl(document.querySelector('[data-jw-chat-launcher]'));
    observeEl(document.querySelector('[data-jw-cookie-banner], #jw-cookie-banner'));
    observeEl(document.querySelector('shopify-chat'));
    observeEl(document.querySelector('.product-sticky-bar, product-sticky-bar'));
    var stickyHost = document.querySelector('.shopify-section--main-product');
    observeEl(stickyHost);
  }

  window.addEventListener('resize', request, { passive: true });
  window.addEventListener('orientationchange', request, { passive: true });
  window.addEventListener('scroll', request, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', request, { passive: true });
    window.visualViewport.addEventListener('scroll', request, { passive: true });
  }
  document.addEventListener('product:rerender', request);
  document.addEventListener('shopify:section:load', request);

  /* Cart drawer / menus toggle html.lock */
  if (window.MutationObserver) {
    new MutationObserver(request).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  window.JwFabStack = {
    request: request,
    refresh: function () {
      bindObservers();
      request();
    }
  };

  function boot() {
    bindObservers();
    request();
    /* Inbox / late widgets mount after first paint */
    window.setTimeout(function () {
      bindObservers();
      request();
    }, 800);
    window.setTimeout(function () {
      bindObservers();
      request();
    }, 2000);
    timer = window.setInterval(request, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
